<template>
  <v-card flat>
    <v-window v-model="step" touchless>
      <v-window-item :value="1">
        <v-card-text
          :class="{ small: $vuetify.breakpoint.smAndDown }"
          class="px-0"
        >
          <v-divider></v-divider>

          <v-list three-line subheader class="parkingProducts">
            <v-card
              v-for="item in parking.plans"
              :key="item.plan.id"
              elevation="0"
              class="pointer"
              @click="goToStep2(item)"
            >
              <v-card-text>
                <v-layout row wrap align-bottom>
                  <v-flex xs7 class="text-xs-left">
                    <v-subheader
                      class="subheading font-weight-bold"
                      style="height: 25px; padding-left: 0px"
                    >
                      {{ item.planName }}
                    </v-subheader>
                  </v-flex>

                  <v-flex
                    xs5
                    class="text-xs-right headline warning--text font-weight-bold"
                  >
                    {{ item.price }}
                  </v-flex>
                </v-layout>
                <v-layout
                  v-html="item.planDescription ? item.planDescription : ''"
                  row
                  wrap
                  align-bottom
                  class="v-list__tile__sub-title"
                >
                </v-layout>
              </v-card-text>

              <v-divider></v-divider>
            </v-card>
          </v-list>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="2">
        <v-form
          ref="formStep1"
          v-model="validCreate"
          v-on:submit.prevent="
            () => {
              return false;
            }
          "
        >
          <advice color="warning" v-if="message">
            <p class="ma-0" v-html="message"></p>
          </advice>

          <advice color="primary" class="my-3">
            <span
              v-if="restrictionAdvice"
              v-html="
                $t('parking.restriction.advice', {
                  minEntryTime:
                    this.$options.filters.formatTimeRounded(minValidDate),
                  minEntryDate: this.$options.filters.formatDate(minValidDate),
                })
              "
            ></span
            ><span v-if="restrictionAdvice"><br /></span>
            <span
              v-if="parking.isFacility"
              v-html="$t('facility.advice')"
            ></span>
            <span v-else v-html="$t('plan.advice')"></span>
          </advice>

          <v-card-title class="headline pb-0">
            {{
              $t('plan.step.0', {
                name: planNameSelected,
                price: planPriceSelected,
              })
            }}
          </v-card-title>

          <v-card-title class="grey--text grey--lighten-1 body-1 pb-0">
            {{ $t(currentTitle, { planName: planNameSelected }) }}
          </v-card-title>

          <v-card-text>
            <reservation-date-time-picker
              :key="timePickerKey"
              :input-date="inputDate"
              :min-date="minDate"
              :input-time="fixedEntryTime"
              :disabled-time="!allowToEnterPlanEntryDateTime"
              ref="reservationDateTimePicker"
              :parking-timezone="parking.timezone"
              @on-date-selected="onDateSelected"
              @on-time-selected="onTimeSelected"
            >
            </reservation-date-time-picker>
            <template v-if="parkingHasBle || parkingHasCamara">
              <reservation-plate-selection
                :plates="user.plates"
                @on-plate-selected="onPlateSelected"
                @on-plate-added="onPlateAdded"
                :key="plateSelectorKey"
              >
              </reservation-plate-selection>
            </template>
            <template v-else-if="parkingHasApr">
              <reservation-tag-selection
                :tags="user.tags"
                @on-tag-selected="onTagSelected"
                @on-plate-changed="onPlateChanged"
              >
              </reservation-tag-selection>
            </template>
          </v-card-text>

          <advice
            :color="mustAcceptCaducity ? 'warning' : 'primary'"
            class="my-3"
          >
            <p class="font-weight-medium">{{ $t('plan.caducity.title') }}</p>
            <p>
              {{ $t('plan.caducity.text', { caducityDateTime: caducity }) }}
            </p>

            <v-checkbox
              v-if="mustAcceptCaducity"
              :label="$t('global.button.agree')"
              class="pa-0"
              :rules="caducityRules"
              v-model="acceptCaducityMessage"
            ></v-checkbox>
          </advice>

          <advice color="warning" class="my-3" v-if="hasObservationAsWarning">
            <p
              class="font-weight-medium"
              v-html="parking.description.observationWarning.title"
            ></p>
            <p v-html="parking.description.observationWarning.text"></p>

            <v-checkbox
              :label="$t('global.button.agree')"
              class="pa-0"
              :rules="warningRules"
              v-model="acceptWarningMessage"
            ></v-checkbox>
          </advice>
        </v-form>
      </v-window-item>

      <v-window-item :value="3">
        <advice color="primary" class="my-3">
          <span
            v-html="
              $t(currentTitle, {
                price: this.$options.filters.addCurrencySymbol(
                  this.subscription.price
                ),
              })
            "
          ></span
          ><br />
          <span class="pb-8">{{ this.planNameSelected }}</span>
          <v-spacer class="mb-2"></v-spacer>
          <span v-if="!parking.isFacility">{{
            $t('global.from.with.date', {
              date: entryDateLocalFullDisplay,
            })
          }}</span>
          <span v-else>{{ entryDateLocalFullDisplay }}</span>
          <br v-if="!parking.isFacility" />
          <span v-if="!parking.isFacility">{{
            $t('global.to.with.date', {
              date: exitDateLocalFullDisplay,
            })
          }}</span>
        </advice>
        <payment-internal
          v-if="step == 3"
          :subscription="subscription"
          :parking="parking"
        ></payment-internal>
      </v-window-item>

      <v-window-item :value="100">
        <advice color="warning">
          <p class="title pb-3" v-html="message"></p>
        </advice>

        <template v-if="alternativeParkingList.lenght > 0">
          <h3 class="grey--text grey--lighten-1 body-1 mb-2 px-3 pt-3">
            {{ $t('reservation.failed.alternatives') }}
          </h3>
          <alternative-parkings
            :parkings="alternativeParkingList"
            :date="this.booking.entryDate"
          ></alternative-parkings>
        </template>
      </v-window-item>

      <v-window-item :value="200">
        <advice color="success">
          <p class="title pb-3" v-html="$t('plan.success1')"></p>

          <p class="subheading mb-2">
            <span
              class="body-2 grey--text grey--lighten-1"
              v-html="$t('global.placeholder.from')"
            ></span>
            <span
              class="subheading font-weight-medium ml-2"
              v-html="entryDateLocalFullDisplay"
            ></span>
          </p>

          <p class="subheading mb-2">
            <span
              class="body-2 grey--text grey--lighten-1"
              v-html="$t('global.placeholder.to')"
            ></span>
            <span
              class="subheading font-weight-medium ml-2"
              v-html="exitDateLocalFullDisplay"
            ></span>
          </p>
        </advice>
      </v-window-item>
    </v-window>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        v-if="step > 1"
        round
        flat
        color="primary"
        class="initialize white--text mr-4"
        @click="goToStep1()"
      >
        {{ backLabel() }}
      </v-btn>
      <v-btn
        v-if="step === 200"
        color="primary"
        round
        outline
        class="initialize white--text mr-4"
        @click="goToCalendar"
      >
        {{ $t('subscription.button.seeSubscription') }}
      </v-btn>
      <v-btn
        :disabled="!valid"
        :loading="isLoading"
        v-if="showBookingButton"
        type="submit"
        color="accent"
        class="initialize white--text mr-4"
        @click="checkAvailability"
        round
        outline
      >
        {{ buyOrAdquireButtonText }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash';
import { EventBus } from '@/services/eventBus';
import ReservationDateTimePicker from '@/components/commons/ReservationDateTimePicker';
import keys from '@/store/keys';
import manageErrorService from '@/services/manageErrorService';
import moment from 'moment';
import PaymentInternal from '@/components/commons/PaymentInternal';
import ReservationTagSelection from '@/components/commons/ReservationTagSelection';
import ReservationPlateSelection from '@/components/commons/ReservationPlateSelection';
import store from '@/store/';
import subscriptionService from '@/services/subscriptionService';
import planService from '@/services/planService';
import reservationService from '@/services/reservationService';
import teletagService from '@/services/teletagService';
import plateService from '@/services/plateService';
import Advice from '@/components/commons/Advice';
import AlternativeParkings from '@/components/commons/AlternativeParkings';

export default {
  name: 'CreatePlan',
  components: {
    [ReservationDateTimePicker.name]: ReservationDateTimePicker,
    [PaymentInternal.name]: PaymentInternal,
    [ReservationTagSelection.name]: ReservationTagSelection,
    [ReservationPlateSelection.name]: ReservationPlateSelection,
    [AlternativeParkings.name]: AlternativeParkings,
    [Advice.name]: Advice,
  },
  props: {
    parking: {
      type: Object,
      required: true,
    },
  },
  watch: {
    entryDate: function (value) {},
    entryTime: function (value) {
      if (this.ignoreUpdate) {
        return true;
      }
      this.exitTime = value;
    },
  },
  computed: {
    restrictionAdvice() {
      if (
        this.parking.restrictions &&
        (this.parking.restrictions.notBeforeMinutes > 0 ||
          !this.parking.restrictions.notBeforeIsAbsolute)
      ) {
        let now = moment();
        let restriction = moment();
        if (!this.parking.restrictions.notBeforeIsAbsolute) {
          restriction = restriction.startOf('day');
        }
        restriction = restriction.add(
          this.parking.restrictions.notBeforeMinutes,
          'minutes');
        return restriction.isAfter(now); // true if the restriction is in future
      } else {
        return false;
      }
    },
    parkingHasApr() {
      return this.parking.hasAPR;
    },
    parkingHasBle() {
      return this.parking.hasBLE;
    },
    parkingHasCamara() {
      return this.parking.hasCamara;
    },
    plateRules() {
      return [
        (v) =>
          /^[a-zA-Z0-9-]+$/.test(v) ||
          this.$i18n.t('plate.validation.valid.characters'),
      ];
    },
    valid() {
      if (this.step === 2) {
        return this.validCreate;
      }
      return true;
    },
    showBookingButton() {
      return this.step === 2;
    },
    entryDate() {
      return this.booking.entryDate;
    },
    entryTime() {
      return this.booking.entryTime;
    },
    entryDateLocalFullDisplay() {
      let entryDateLocal = this.getBookingEntryDateAsMoment();
      if (entryDateLocal === null) {
        return '';
      }
      return entryDateLocal.format('LLLL');
    },
    exitDateLocalFullDisplay() {
      let exitDateLocal = this.getBookingExitDateAsMoment();
      if (exitDateLocal === null) {
        return '';
      }
      return exitDateLocal.format('LLLL');
    },
    isLogged() {
      return store.state.isLogged;
    },
    warningRules() {
      return [(v) => v || this.$i18n.t('plate.validation.acceptWarning')];
    },
    caducityRules() {
      return [
        (v) =>
          !this.mustAcceptCaducity ||
          v ||
          this.$i18n.t('plate.validation.acceptCaducity'),
      ];
    },
    canBuySubscription() {
      return subscriptionService.canBuySubcription();
    },
    buyOrAdquireButtonText() {
      if (this.canBuySubscription) {
        return this.$i18n.t('subscription.button.check');
      } else {
        return this.$i18n.t('subscription.button.adquire');
      }
    },
    hasObservationAsWarning() {
      if (_.isEmpty(this.parking)) {
        return false;
      }
      if (this.parking.description.observationWarning === null) {
        return false;
      }
      return typeof this.parking.description.observationWarning !== 'undefined';
    },
    allowToEnterPlanEntryDateTime() {
      if (!this.planResponseSelected) {
        return false;
      }

      if (!this.planResponseSelected.plan) {
        return false;
      }

      return this.planResponseSelected.plan.minuteStart === null;
    },
    fixedEntryTime() {
      if (!this.planResponseSelected) {
        return '';
      }

      if (!this.planResponseSelected.plan) {
        return '';
      }

      if (this.allowToEnterPlanEntryDateTime) {
        return this.booking.entryTime;
      }
      const minuteStart = this.planResponseSelected.plan.minuteStart;
      const hours = (minuteStart / 60).toString().padStart(2, '0');
      const minutes = (minuteStart % 60).toString().padStart(2, '0');
      this.booking.entryTime = `${hours}:${minutes}`;

      this.calculeCaducity();
      return `${hours}:${minutes}`;
    },
  },
  data() {
    return {
      mustAcceptCaducity: false,
      caducity: moment(),
      step: 1,
      validCreate: false,
      isLoading: false,
      tagSelected: { plate: '' },
      plateSelected: { alias: '' },
      minDate: this.calculeInitialDateTime(),
      minValidDate: this.calculeInitialDateTime(),
      inputDate: this.calculeInitialDateTime(),
      booking: {
        parking: this.parking,
        entryDate: this.calculeInitialDateTime('moment').format('YYYY-MM-DD'),
        entryTime: '',
      },
      resultBooking: {
        parking: this.parking,
        entryDate: null,
        entryTime: null,
      },
      subscription: {
        id: 0,
        type: 'CUSTOM',
        price: 0,
      },
      user: {
        tags: [],
        plates: [],
      },
      plateSelectorKey: 0, // used to ensure the plate selector is filled after navigation between steps/plans
      timePickerKey: 1000, // used to ensure the time picker is updated after navigation between steps/plans
      currentTitle: 'plan.step.1',
      planNameSelected: '',
      planPriceSelected: '',
      planDescriptionSelected: '',
      exitDate: moment().toDate(),
      exitTime: '00:00',
      acceptWarningMessage: false,
      acceptCaducityMessage: false,
      message: '',
      alternativeParkingList: [],
      ignoreUpdate: false,
      planResponseSelected: {},
      job: null,
    };
  },
  beforeDestroy() {
    this.job.stop();
  },
  async mounted() {
    if (typeof this.$route.query.ok !== 'undefined') {
      if (this.$route.query.ok.indexOf('OK') >= 0) {
        EventBus.$emit(keys.hideBookingTabs, {
          hidden: true,
        });

        let subscriptionId = this.$route.query.subscriptionId;
        if (typeof subscriptionId === 'undefined') {
          subscriptionId = this.$route.query.subscription;
        }

        let params = {
          id: subscriptionId,
        };

        let results = await reservationService.get(params);

        if (results.error) {
          manageErrorService.handle(results.data);
          return false;
        }

        this.ignoreUpdate = true;

        this.resultBooking.entryDate = moment
          .utc(results.data.startLocal)
          .format('YYYY-MM-DD');
        this.resultBooking.entryTime = moment
          .utc(results.data.startLocal)
          .format('HH:mm');

        this.exitDate = moment.utc(results.data.endLocal).format('YYYY-MM-DD');
        this.exitTime = moment.utc(results.data.endLocal).format('HH:mm');

        this.step = 200;
      }
    }

    if (this.isLogged && (this.parking.hasBLE || this.parking.hasCamara)) {
      this.loadPlates();
    } else if (this.isLogged && this.parking.hasAPR) {
      this.loadTacs();
    }

    this.booking.entryTime = this.getExternalNearestTime(
      this.calculeInitialDateTime('moment')
    );

    var CronJob = require('cron').CronJob;
    this.job = new CronJob(
      '*/1 * * * *',
      function () {
        if (!this.planResponseSelected) {
          return;
        }

        if (!this.planResponseSelected.plan) {
          return;
        }

        var aux = this.calculeInitialDateTime();
        var planMaxExit = this.calculeInitialDateTime('moment').add(1, 'day');
        if (!this.allowToEnterPlanEntryDateTime) {
          planMaxExit = moment(aux)
            .startOf('day')
            .add(this.planResponseSelected.plan.minuteStart, 'minute')
            .add(this.planResponseSelected.plan.duration, 'minute');
        }
        if (moment(aux).isSameOrAfter(planMaxExit)) {
          this.minDate = moment(aux).add(1, 'day').toDate();
          if (moment(this.inputDate).isBefore(this.minDate)) {
            this.inputDate = moment(aux).add(1, 'day').toDate();
            this.booking.entryDate = moment(this.inputDate).format(
              'YYYY-MM-DD'
            );
          }
        } else {
          this.minDate = aux;
        }
        this.minValidDate = aux;
      },
      null,
      false,
      this.parking.timezone,
      this
    );
    this.job.start();
  },
  methods: {
    calculeInitialDateTime(type = 'date') {
      let initial = moment();
      if (this.parking.restrictions) {
        if (this.parking.restrictions.notBeforeMinutes > 0) {
          let aux = _.cloneDeep(initial)
          if (!this.parking.restrictions.notBeforeIsAbsolute) {
            aux = aux.startOf('day');
          }
          aux = aux.add(
            this.parking.restrictions.notBeforeMinutes,
            'minutes'
          );
          if (aux.isAfter(initial)) {
            initial = aux;
          }
        }
      }

      let minutes = initial.minutes();
      let hours = initial.hours();
      if (minutes === 0) {
        minutes = 0;
      } else if (minutes <= 5) {
        minutes = 5;
      } else if (minutes <= 10) {
        minutes = 10;
      } else if (minutes <= 15) {
        minutes = 15;
      } else if (minutes <= 20) {
        minutes = 20;
      } else if (minutes <= 25) {
        minutes = 25;
      } else if (minutes <= 30) {
        minutes = 30;
      } else if (minutes <= 35) {
        minutes = 35;
      } else if (minutes <= 40) {
        minutes = 40;
      } else if (minutes <= 45) {
        minutes = 45;
      } else if (minutes <= 50) {
        minutes = 50;
      } else if (minutes <= 55) {
        minutes = 55;
      } else {
        minutes = 0;
        if (hours === 23) {
          hours = 0;
          this.form.day = moment().add(1, 'day').format('YYYY-MM-DD');
        } else {
          hours++;
        }
      }
      initial = initial
        .set('hours', hours)
        .set('minutes', minutes)
        .set('seconds', 0)
        .set('milliseconds', 0);

      if (type === 'moment') {
        return initial;
      }
      return initial.toDate();
    },
    getExternalNearestTime(arg) {
      return this.$refs.reservationDateTimePicker.getExternalNearestTime(arg);
    },
    onPlateSelected(params) {
      this.plateSelected = params.plate;
    },
    onPlateAdded(params) {
      this.loadPlates();
    },
    onTagSelected(params) {
      this.tagSelected = params.tag;
    },
    onPlateChanged(params) {
      this.tagSelected.plate = params.plate;
    },
    onDateSelected(params) {
      if (this.step < 3 && params.date !== this.booking.entryDate) {
        this.booking.entryDate = params.date;
        if (this.booking.entryDate && this.booking.entryTime) {
          this.inputDate = moment(
            this.booking.entryDate + ' ' + this.booking.entryTime
          ).toDate();
        }
      }
      this.calculeCaducity();
    },
    onTimeSelected(params) {
      if (this.step < 3 && params.timeSelected !== this.booking.entryTime) {
        this.booking.entryTime = params.timeSelected;
        if (this.booking.entryDate && this.booking.entryTime) {
          this.inputDate = moment(
            this.booking.entryDate + ' ' + this.booking.entryTime
          ).toDate();
        }
      }
      this.calculeCaducity();
    },
    calculeCaducity() {
      if (!this.planResponseSelected) {
        return;
      }

      if (!this.planResponseSelected.plan) {
        return;
      }
      if (this.booking.entryDate && this.booking.entryTime) {
        let calculedCaducity = moment(
          this.booking.entryDate + ' ' + this.booking.entryTime
        ).add(this.planResponseSelected.plan.duration, 'minutes');
        this.mustAcceptCaducity = false;

        if (this.planResponseSelected.plan.type === 'NATURAL') {
          let maxEnd = moment(this.booking.entryDate + ' 00:00')
            .add(this.planResponseSelected.plan.duration - 1, 'minutes')
            .endOf('day');
          if (calculedCaducity.isAfter(maxEnd)) {
            this.mustAcceptCaducity = true;
            calculedCaducity = maxEnd.add(1, 'seconds');
          }
        }

        this.exitDate = calculedCaducity;
        this.exitTime = calculedCaducity.format('HH:mm');
        this.caducity = calculedCaducity.format('LLLL');
      }
    },
    async loadPlates() {
      this.plateSelectorKey++;
      let results = await plateService.list({});

      if (results.error) {
        manageErrorService.handle(results.data);
        this.isLoading = false;
        this.valid = true;
        return;
      }

      let data = results.data;
      this.user.plates = data;
      if (data.length > 0) {
        this.plateSelected = data[0];
      }
    },
    async loadTacs() {
      let results = await teletagService.list({});

      if (results.error) {
        manageErrorService.handle(results.data);
        this.isLoading = false;
        this.valid = true;
        return;
      }
      let data = results.data;
      this.user.tags = data;
      if (data.length > 0) {
        this.tagSelected = data[0];
      }
    },
    async checkAvailability() {
      if (!this.$refs.formStep1.validate()) {
        return;
      }

      if (this.userHasErrors()) {
        return;
      }
      this.isLoading = true;

      EventBus.$emit(keys.hideBookingTabs, {
        hidden: true,
      });

      let entryDateLocal = this.getBookingEntryDateAsMoment();

      let params = {
        parkingId: this.booking.parking.id,
        start: entryDateLocal.format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        planId: this.planResponseSelected.plan.id,
      };

      if (this.parkingHasBle || this.parkingHasCamara) {
        params.plateId = this.plateSelected.id;
        params.plate = this.plateSelected.code;
      }

      if (this.parkingHasApr) {
        params.teletagId = this.tagSelected.id;
        params.plate = this.tagSelected.plate;
      }

      let result = await planService.create(params);

      if (result.error) {
        this.currentTitle = '';
        this.message = result.data.error;
        // this.alternativeParkingList = result.data.alternatives;
        this.step = 100;
        this.isLoading = false;
        return;
      }

      if (!this.canBuySubscription || result.data.price === 0) {
        this.step = 200;
        this.isLoading = false;
        return;
      }
      this.subscription.id = result.data.subscriptionId;
      this.subscription.price = result.data.price;

      store.commit('UPDATE_LAST_SUBSCRIPTION', {
        lastSubscription: { ...this.subscription },
      });

      this.currentTitle = this.parking.isFacility
        ? 'plan.paying.service.title'
        : 'plan.paying.title';
      this.step = 3;
      this.isLoading = false;
    },
    getBookingEntryDateAsMoment() {
      if (
        _.isEmpty(this.booking.entryDate) ||
        _.isEmpty(this.booking.entryTime)
      ) {
        return null;
      }

      let entryTime =
        this.resultBooking.entryTime != null
          ? this.resultBooking.entryTime
          : this.booking.entryTime;

      let selectedDate =
        this.resultBooking.entryDate != null
          ? moment(this.resultBooking.entryDate).toDate()
          : moment(this.booking.entryDate).toDate();
      let hoursMinutes = entryTime.split(':');
      return moment([
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        hoursMinutes[0],
        hoursMinutes[1],
      ]);
    },
    getBookingExitDateAsMoment() {
      if (this.step === 200) {
        let selectedDate = moment(this.exitDate).toDate();
        let hoursMinutes = this.exitTime.split(':');
        return moment([
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate(),
          hoursMinutes[0],
          hoursMinutes[1],
        ]);
      }

      if (
        typeof this.planResponseSelected === 'undefined' ||
        this.planResponseSelected === null ||
        Object.keys(this.planResponseSelected).length === 0
      ) {
        return null;
      }

      const startDate = this.getBookingEntryDateAsMoment();

      if (typeof startDate === 'undefined' || startDate === null) {
        return null;
      }
      // const exitDate = moment(startDate);
      // return exitDate.add(this.planResponseSelected.plan.duration, 'minutes');
      return moment(this.exitDate);
    },
    userHasErrors() {
      let user = store.state.user;
      let hasRoleBuySubscription = _.find(
        store.state.user.roles,
        (it) => it.authority === 'ROLE_BUY_SUBSCRIPTION'
      );
      if (
        !this.parking.hasBLE &&
        !this.parking.hasCamara &&
        !this.parking.isFacility
      ) {
        if (this.parking.hasAPR && !user.activeTags) {
          this.$emit('on-user-error', { error: 'showErrorNoTags' });
          return true;
        }
      } else if (user.status !== 'ACTIVED') {
        this.$emit('on-user-error', { error: 'showErrorNotActived' });
        return true;
      } else if (user.balance.total < 0 && hasRoleBuySubscription) {
        this.$emit('on-user-error', { error: 'showErrorNoBalance' });
        return true;
      }
      return false;
    },
    goToStep1() {
      EventBus.$emit(keys.hideBookingTabs, {
        hidden: false,
      });
      // this.$router.replace(window.location.pathname);
      this.ignoreUpdate = false;
      this.currentTitle = 'plan.step.1';
      this.step = 1;
    },
    goToStep2(plan) {
      this.currentTitle = 'plan.step.2';
      this.planResponseSelected = plan;
      this.planNameSelected = plan.planName;
      this.planPriceSelected = plan.price;
      this.planDescriptionSelected = plan.planDescription;
      this.step = 2;

      this.message = '';
      EventBus.$emit(keys.hideBookingTabs, {
        hidden: true,
      });

      this.restartDates();
    },
    restartDates() {
      this.isLoading = false;
      this.$nextTick(() => {
        // this.booking.entryDate = moment().format('YYYY-MM-DD');
        this.inputDate = this.calculeInitialDateTime();
        this.booking.entryDate = moment(this.inputDate).format('YYYY-MM-DD');
        this.resultBooking.entryDate = null;
        this.resultBooking.entryTime = null;
        if (this.planResponseSelected && this.planResponseSelected.plan) {
          let planMaxExit = moment(this.inputDate).add(
            this.planResponseSelected.plan.duration,
            'minute'
          );
          if (!this.allowToEnterPlanEntryDateTime) {
            planMaxExit = moment(this.inputDate)
              .startOf('day')
              .add(this.planResponseSelected.plan.minuteStart, 'minute')
              .add(this.planResponseSelected.plan.duration, 'minute');
          }
          if (moment(this.inputDate).isSameOrAfter(planMaxExit)) {
            this.inputDate = moment(this.inputDate).add(1, 'day').toDate();
            this.booking.entryDate = moment(this.inputDate).format(
              'YYYY-MM-DD'
            );
            this.minDate = moment(this.minDate).add(1, 'day').toDate();
          }
        }
        if (this.allowToEnterPlanEntryDateTime) {
          this.booking.entryTime =
            this.$refs.reservationDateTimePicker.getExternalNearestTime();
            this.timePickerKey += 1;
        } else {
          this.booking.entryTime = this.fixedEntryTime;
        }
      });

      this.calculeCaducity();
    },
    goToCalendar() {
      store.commit('SET_RESTORE_HOME_DATA', { data: false });
      store.commit('CHANGE_SHOWING_PARKING_AS_LIST', { showAsList: false });

      this.$router.push({ path: this.$i18n.t('urlMyReservations') });
    },
    backLabel() {
      if (this.step === 200) {
        return this.$i18n.t('subscription.button.doAnother');
      } else {
        return this.$i18n.t('global.action.back');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-text-field--outline.v-text-field--single-line input {
  margin-top: 10px !important;
}

.parkingProducts .v-avatar {
  width: auto !important;
  height: auto !important;
}
.parkingProducts .v-list__tile__avatar {
  min-width: 150px;
}
.small .parkingProducts .v-list__tile__avatar {
  min-width: 130px;
}
</style>

<style>
/* .v-list__tile.v-list__tile--avatar.v-list__tile--link {
  /*padding:0 !important*
} */
.pointer:hover {
  background-color: #fafafa !important;
  cursor: pointer;
}
</style>
